function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tag");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(-31.000000, -441.000000)",
  stroke: "#155C28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy",
  transform: "translate(10.000000, 424.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "tag",
  transform: "translate(22.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 7,
  x2: 12,
  y2: 11,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6,
  y1: 8,
  x2: 9,
  y2: 11,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5,3 C16.3283737,3 17,3.6716263 17,4.5 C17,5.3283737 16.3283737,6 15.5,6 C14.6716263,6 14,5.3283737 14,4.5 C14,3.6716263 14.6716263,3 15.5,3 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6266783,0 L10.2943042,0 C9.9147519,0 9.5520883,0.156447311 9.29253493,0.432895113 L0.371721434,9.91834365 C-0.145607527,10.4676837 -0.119829967,11.3316941 0.429498724,11.8481449 C0.442831944,11.8605895 0.456165165,11.8721452 0.469498385,11.8845897 L9.38586748,19.6615731 C9.94408498,20.1478012 10.7867445,20.105134 11.2934069,19.5655719 L19.6302253,10.6614638 C19.8675567,10.4081274 20,10.0739011 20,9.72723022 L20,1.36890648 C19.9991111,0.611563949 19.3848941,-0.000887933311 18.6275672,0 C18.6275672,0 18.6266783,0 18.6266783,0 Z",
  id: "Path"
})))));

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.4e992886.svg";
export { ForwardRef as ReactComponent };